export default __webpack_public_path__ + "static/media/14.723fd7ed.png";